import { FunctionComponent, h } from "preact"

type ContainerProps = h.JSX.HTMLAttributes<HTMLDivElement>

const Container: FunctionComponent<ContainerProps> = ({ children }) => {
  return <div className="container-fluid py-4 px-5">{children}</div>
}

export default Container
